import React from "react";
import { WHOLESALE_COMMODITIES, FREQUENCIES, MIXED_CASE } from "../../mock";
import MixedCaseBuilder from "./MixedCaseBuilder";

const pill = (on) =>
  `px-4 py-2 rounded-full text-[12px] tracking-[0.08em] uppercase font-medium border transition-colors ${
    on ? "bg-[#1f4a33] border-[#1f4a33] text-[#f6f1e7]" : "border-[#10271a]/15 text-[#10271a]/75 hover:border-[#1f4a33]/50"
  }`;

export default function StepVolumes({ selected, lines, onChange }) {
  const items = WHOLESALE_COMMODITIES.filter((c) => selected.includes(c.id));
  return (
    <div data-testid="step-volumes">
      <h2 className="font-display text-3xl md:text-5xl font-light leading-[1.05] text-[#10271a]">
        Grades, volumes <em className="italic text-[#1f4a33]">and cadence.</em>
      </h2>
      <p className="mt-4 text-[#5e6b61] text-lg max-w-xl">Indicative is fine — our trade desk will refine the offer with you.</p>
      <div className="mt-10 space-y-6">
        {items.map((c) => {
          const line = lines[c.id];
          const set = (patch) => onChange(c.id, { ...line, ...patch });
          return (
            <div key={c.id} className="rounded-3xl border border-[#10271a]/10 bg-[#fbf8f1] p-6 md:p-8" data-testid={`volume-line-${c.id}`}>
              <div className="flex items-center gap-4">
                <img src={c.image} alt="" className="h-14 w-14 rounded-2xl object-cover" />
                <div>
                  <p className="text-[#7c5230] text-[11px] tracking-[0.18em] uppercase">{c.origin}</p>
                  <h3 className="font-display text-2xl text-[#10271a] leading-none mt-1">{c.name}</h3>
                </div>
              </div>

              <Label>Grade / form</Label>
              <div className="flex flex-wrap gap-2">
                {c.grades.map((g) => (
                  <button key={g} type="button" onClick={() => set({ grade: g })} className={pill(line.grade === g)} data-testid={`grade-${c.id}-${g.split(" ")[0].toLowerCase()}`}>{g}</button>
                ))}
                {c.id === "wine" && (
                  <button type="button" onClick={() => set({ grade: MIXED_CASE, unit: "cases of 6", mix: line.mix || {} })} className={`${pill(line.grade === MIXED_CASE)} ${line.grade === MIXED_CASE ? "" : "border-dashed border-[#1f4a33]/50 text-[#1f4a33]"}`} data-testid="grade-wine-mixed">✦ {MIXED_CASE} · build your own</button>
                )}
              </div>
              {c.id === "wine" && line.grade === MIXED_CASE && <MixedCaseBuilder mix={line.mix || {}} onChange={(mix) => set({ mix })} />}

              <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto] gap-6 mt-2">
                <div>
                  <Label>{line.grade === MIXED_CASE ? "Number of mixed cases per shipment" : "Volume per shipment"}</Label>
                  <div className="flex items-center gap-3">
                    <input
                      type="number"
                      min="0"
                      inputMode="decimal"
                      value={line.volume}
                      onChange={(e) => set({ volume: e.target.value })}
                      placeholder="e.g. 320"
                      data-testid={`volume-input-${c.id}`}
                      className="w-40 bg-transparent border-b border-[#1f4a33]/25 py-2.5 text-2xl font-display text-[#10271a] placeholder:text-[#5e6b61]/40 focus:outline-none focus:border-[#1f4a33]"
                    />
                    <div className="flex gap-2">
                      {(line.grade === MIXED_CASE ? ["cases of 6"] : c.units).map((u) => (
                        <button key={u} type="button" onClick={() => set({ unit: u })} className={pill(line.unit === u)} data-testid={`unit-${c.id}-${u.replace(/\W/g, "").toLowerCase()}`}>{u}</button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <Label>Frequency</Label>
              <div className="flex flex-wrap gap-2">
                {FREQUENCIES.map((f) => (
                  <button key={f} type="button" onClick={() => set({ frequency: f })} className={pill(line.frequency === f)} data-testid={`frequency-${c.id}-${f.split(" ")[0].toLowerCase()}`}>{f}</button>
                ))}
              </div>
              <p className="mt-5 text-xs text-[#5e6b61]">{c.note}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function Label({ children }) {
  return <p className="mt-7 mb-3 text-[11px] tracking-[0.18em] uppercase text-[#5e6b61]">{children}</p>;
}
